export default "__VITE_ASSET__b884e243__"